import React from "react";
import { ExpandedDescriptionTextSection, ExpandedDescriptionTextSectionGrouping, ExpandedDescriptionTextSectionTypes } from "~/ProductDetails/ProductDetailPageResult";
import ContentCustomCalculator from "./ContentSection/ContentCustomCalculator";
import ContentTextImageDouble from "./ContentSection/ContentTextImageDouble";
import ContentTextImageLeft from "./ContentSection/ContentTextImageLeft";
import ContentTextImageRight from "./ContentSection/ContentTextImageRight";
import ContentTextImageTriple from "./ContentSection/ContentTextImageTriple";
import ProfitCalculator from "./ContentSection/ProfitCalculator";
import HoldOvenCalculator from "./ContentSection/HoldOvenCalculator";
import CottonCandyCalculator from "./ContentSection/CottonCandyCalculator";
import FrycloneFilterMachineCalculator from "./ContentSection/FrycloneFilterMachineCalculator";
interface Props {
  sectionsGrouping: ExpandedDescriptionTextSectionGrouping[];
  price: number;
}
const ExpandedContentSection = ({
  sectionsGrouping,
  price
}: Props) => {
  const createCustomCalculator = (customCalculatorFileName: string) => {
    switch (customCalculatorFileName.toLowerCase()) {
      case "holdovens.cfm":
        return <HoldOvenCalculator price={price} />;
      case "fryclone.cfm":
        return <FrycloneFilterMachineCalculator price={price} />;
      case "slushy.cfm":
      case "popcorn.cfm":
        return <ProfitCalculator />;
      case "cottoncandy.cfm":
        return <CottonCandyCalculator price={price} />;
      default:
        return <></>;
    }
  };
  const renderGroupSection = (sectionsGroup: ExpandedDescriptionTextSectionGrouping) => {
    const primarySection = sectionsGroup.sections[0] as ExpandedDescriptionTextSection;
    if (primarySection.body.indexOf("<gsp_script") > 0) {
      return <></>;
    }
    switch (sectionsGroup.type) {
      case ExpandedDescriptionTextSectionTypes.TextImageLeft:
        return <ContentTextImageLeft section={primarySection} key={primarySection?.headline} />;
      case ExpandedDescriptionTextSectionTypes.TextImageRight:
        return <ContentTextImageRight section={primarySection} key={primarySection?.headline} />;
      case ExpandedDescriptionTextSectionTypes.TextImageDouble:
        return <ContentTextImageDouble sections={sectionsGroup.sections} />;
      case ExpandedDescriptionTextSectionTypes.TextImageTriple:
        return <ContentTextImageTriple sections={sectionsGroup.sections} />;
      case ExpandedDescriptionTextSectionTypes.CustomCalculator:
        return <ContentCustomCalculator headline={primarySection.headline} body={primarySection.body} key={primarySection.headline}>
            {createCustomCalculator(primarySection.customCalculatorFileName)}
          </ContentCustomCalculator>;
      default:
        return <></>;
    }
  };
  return <>
      {sectionsGrouping.map(data => <React.Fragment key={data.sections[0]?.headline}>
          {renderGroupSection(data)}
        </React.Fragment>)}
    </>;
};
export default ExpandedContentSection;